'use client';
import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/navigation'; // Importing useRouter from next/navigation
import emailIcon from "../../assets/icons/email.png";
import homeIcon from "../../assets/icons/home.png";
import phoneIcon from "../../assets/icons/phone-call.png";
import fbIcon from "../../assets/icons/facebook.png";
import instaIcon from "../../assets/icons/instagram.png";
import xIcon from "../../assets/icons/x.png";
import youtubeIcon from "../../assets/icons/youtube.png";
import tiktokIcon from "../../assets/icons/tiktok.png";
import linkedinColor from "../../assets/icons/linkedin-color.png";
import Image from 'next/image';
import axios from 'axios';
import RentalDirectoryPageBannerOne from "../../components/banners/rental-directory-page-banner-one";

const SectionOne = () => {
    const router = useRouter();
    const [data, setData] = useState([]);
    console.log(data,'test')
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    const fetchingRentalCompaniesApi = async () => {
        try {
            let response = await axios({
                method: 'GET',
                url: `${process.env.NEXT_PUBLIC_REACT_APP_HOST_URL}/api/dealer`
            });
            if (response.status === 200) {
                console.log(response,'test5')
                const sortedData = response.data.sort((a, b) => a.name.localeCompare(b.name));
                setData(sortedData);
            }
        } catch (error) {
            console.log('Failed while fetching rental companies api: ', error);
        }
    };

    const formatUAEPhoneNumber = (contactNumber) => {
        const cleanedNumber = contactNumber.replace(/\D/g, '');
        if (cleanedNumber.startsWith('971')) {
          return `+971 ${cleanedNumber.slice(3, 5)} ${cleanedNumber.slice(5, 8)} ${cleanedNumber.slice(8)}`;
        } else if (cleanedNumber.startsWith('05')) {
          return `${cleanedNumber.slice(0, 3)} ${cleanedNumber.slice(3, 6)} ${cleanedNumber.slice(6)}`;
        }
        return contactNumber;
      };
      

    useEffect(() => {
        fetchingRentalCompaniesApi();
    }, []);

    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
    };

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(data.length / itemsPerPage);

    return (
        <div className="rental-companies-section-one">
            <div className="rental-companies-section-one-sub-section">
                <div className="rental-companies-section-one-header">
                    <h3>Car Rental Companies Directory in Dubai</h3>
                </div>

                <div className="rental-companies-section-one-body">
                    <div className="rental-companies-section-one-list-container col-md-8">
                        {currentItems.length > 0 ? currentItems.map((item, index) => (
                            <div 
                                onClick={() => { router.push(`/company-details?dealer_id=${item.id}`) }} 
                                key={index} 
                                className='rental-companies-section-one-list-item'
                            >
                                <div className='rental-companies-section-one-list-item-header flex-wrap'>
                                    <div>
                                        <div className='image-logo'>
                                            <Image 
                                                src={item.logo} 
                                                className='rental-companies-section-one-list-item-dealer-logo' 
                                                alt="dealer-logo" 
                                                height="50"
                                                width="50"
                                            />
                                        </div>
                                       
                                        <h3 className='mb-0'>{item.name}</h3>
                                    </div>
                                    <div className='social-links-container-rental-companies'>
                                        {item.tiktokLink && (
                                            <Image 
                                                onClick={() => { window.open(item.tiktokLink, "_blank"); }} 
                                                className='links' 
                                                src={tiktokIcon} 
                                                alt="social-media-icon" 
                                                style={{ height: 20, width: 20 }} 
                                            />
                                        )}
                                        {item.facebookLink && (
                                            <Image 
                                                onClick={() => { window.open(item.facebookLink, "_blank"); }} 
                                                className='ms-3 links' 
                                                src={fbIcon} 
                                                alt="social-media-icon" 
                                                style={{ height: 25, width: 25 }} 
                                            />
                                        )}
                                        {item.linkedinLink && (
                                            <Image 
                                                onClick={() => { window.open(item.linkedinLink, "_blank"); }} 
                                                className='ms-3 links' 
                                                src={linkedinColor} 
                                                alt="social-media-icon" 
                                                style={{ height: 20, width: 20 }} 
                                            />
                                        )}
                                        {item.youtubeLink && (
                                            <Image 
                                                onClick={() => { window.open(item.youtubeLink, "_blank"); }} 
                                                className='ms-3 links' 
                                                src={youtubeIcon} 
                                                alt="social-media-icon" 
                                                style={{ height: 25, width: 22 }} 
                                            />
                                        )}
                                        {item.instagramLink && (
                                            <Image 
                                                onClick={() => { window.open(item.instagramLink, "_blank"); }} 
                                                className='ms-3 links' 
                                                src={instaIcon} 
                                                alt="social-media-icon" 
                                                style={{ height: 20, width: 20 }} 
                                            />
                                        )}
                                        {item.twitterLink && (
                                            <Image 
                                                onClick={() => { window.open(item.twitterLink, "_blank"); }} 
                                                className='ms-3 links' 
                                                src={xIcon} 
                                                alt="social-media-icon" 
                                                style={{ height: 20, width: 20 }} 
                                            />
                                        )}
                                    </div>
                                </div>
                                <div className='rental-companies-section-one-list-item-body'>
                                    <div className='rental-companies-section-one-list-item-details'>
                                        <Image src={homeIcon} alt="home-icon" />
                                        <span className="para">{item.address}</span>
                                    </div>
                                    <div className='rental-companies-section-one-list-item-details'>
                                        <Image src={emailIcon} alt="email-icon" />
                                        <span className="para">{item.user.email.slice(0, 10)}...</span>
                                    </div>
                                    <div className='rental-companies-section-one-list-item-details'>
                                        <Image src={phoneIcon} alt="phone-icon" />
                                        <span className="para">{formatUAEPhoneNumber(item.contactNumber)}...</span>
                                    </div>
                                </div>
                                <div className='rental-companies-section-one-list-item-footer'>
                                    <a 
                                        onClick={() => { router.push(`/company-details?dealer_id=${item.id}`) }} 
                                        className='links primary_text_color'
                                    >
                                        More info...
                                    </a>
                                </div>
                            </div>
                        )) : ''}
                    </div>
                    <div className="rental-companies-section-one-banner-portion-container col-md-4">
                        <div className="d-flex justify-content-end mt-4">
                            <RentalDirectoryPageBannerOne />
                        </div>
                    </div>
                </div>
                <div className="pagination">
                    {Array.from({ length: totalPages }, (_, index) => (
                        <button 
                            key={index} 
                            onClick={() => handlePageChange(index + 1)}
                            className={`btn btn-primary m-1 text-center page-button ${index + 1 === currentPage ? 'active' : ''}`}
                        >
                            {index + 1}
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default SectionOne;
